export const toCamelCase = (prop) => {
    const parts = prop.split('_');
    return `${parts[0]}${parts
        .slice(1)
        .map((part) => part[0].toUpperCase() + part.slice(1))
        .join('')}`;
};
export const buildCamelCaseMethod = (prefix, prop, suffix = '') => {
    const camelCase = toCamelCase(prop);
    return `${prefix}${camelCase[0].toUpperCase() + camelCase.slice(1)}${suffix}`;
};
